import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from 'js-cookie'

//helpers
export const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <GlobalContext.Provider
      value={{
        isLoading,
        setIsLoading
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
